// Fire-and-forget WhatsApp click tracker
// Calls /api/whatsapp-click without blocking navigation to WhatsApp.

const API = process.env.REACT_APP_BACKEND_URL;

export const trackWhatsAppClick = (meta = {}) => {
  try {
    const payload = {
      page: typeof window !== 'undefined' ? window.location.pathname : null,
      package: meta.packageName || null,
      button_location: meta.location || null,
      user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
      referrer: typeof document !== 'undefined' ? document.referrer : null,
    };
    const url = `${API}/api/whatsapp-click`;
    const body = JSON.stringify(payload);
    // sendBeacon is ideal — it survives page navigation (WhatsApp deep link)
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch (_) {
    // Never block the user over analytics
  }
};
